import { IconError } from '@blockchain-com/icons'
import I18n from 'components/I18n'
import Icon from 'components/Icons/Icon'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

const Content = styled.div`
  display: grid;
  gap: 1.5rem;
  justify-items: center;
  color: ${color('white')};
  text-align: center;
  line-height: 150%;
  margin: 40px 30px;

  h1 {
    font-weight: 600;
    font-size: 1.25rem;
    margin: 0;
  }
`

const Restriction = ({ children }) => (
  <Content>
    <Icon color='orange500' size='lg'>
      <IconError />
    </Icon>
    <h1>
      <I18n data={messages.account_restricted} />
    </h1>
    {children}
  </Content>
)

export default Restriction
